export default (o) => {
	return Object.keys(o).every((x) => {
		return o[x] === '' || o[x] === null
	})
}
